import { render, staticRenderFns } from "./EditorIFrame.vue?vue&type=template&id=f2e5ba56"
import script from "./EditorIFrame.vue?vue&type=script&lang=js"
export * from "./EditorIFrame.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports